const NAME_SPACE = 'VimeoPlayerComponent';

export { NAME_SPACE };
